import {
    patchState,
    signalStore,
    withMethods,
    withState,
  } from '@ngrx/signals';
import { LearnerReports, learnerReportsInitialState } from './learner-reports.model';
  
export const LearnerReportsStore = signalStore(
    withState(learnerReportsInitialState),

    withMethods(({...store}) => ({
        setLearnerMetrics(learnerMetricsSignal: LearnerReports["learnerMetricsSignal"]) {
            patchState(store, {learnerMetricsSignal});
        },
        setLearnerMetricsLoading(isLoading: boolean) {
            patchState(store, {learnerMetricsLoadingSignal: isLoading});
        },
        resetStore() {
            patchState(store, learnerReportsInitialState );
        }
    }))
);



